//START GENAI@CHATGPT4
//START GENAI@CHATGPT4
//START GENAI@CHATGPT4

export function formatDate(date: string) {
  return new Date(date || 0);
}

/**
 * START GENAI@GHCOPILOT
 * Removes unwanted properties from the profile object
 * @param profile - The profile object
 * @returns The profile object with unwanted properties removed
 * END GENAI@GHCOPILOT
 */
//eslint-disable-next-line
export function removeUnwantedProfileProperties(profile: any) {
  let { maskedCards } = profile;
  const { maskedConsumer } = profile;

  //START GENAI@CHATGPT4
  //eslint-disable-next-line
  function clean(obj: any) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        //eslint-disable-next-line
        delete obj[propName];
      }
    }

    return obj;
  }

  //eslint-disable-next-line
  maskedCards = profile.maskedCards.map((maskedCard: any) => {
    const {
      srcDigitalCardId,
      panBin,
      panLastFour,
      panExpirationMonth,
      panExpirationYear,
      tokenBinRange,
      tokenLastFour,
      maskedCardholderFullName,
      maskedCardholderFirstName,
      maskedCardholderLastName,
      paymentCardDescriptor,
      paymentCardType,
      countryCode,
      maskedBillingAddress,
      paymentAccountReference,
      dateOfCardCreated,
      dateOfCardLastUsed
    } = maskedCard;

    let { dcf, digitalCardData, digitalCardFeatures } = maskedCard;

    if (digitalCardData) {
      const {
        artUri,
        authenticationMethods,
        artHeight,
        artWidth,
        descriptorName,
        pendingEvents,
        presentationName,
        status
      } = digitalCardData;

      digitalCardData = clean({
        artHeight,
        artUri,
        artWidth,
        authenticationMethods,
        descriptorName,
        pendingEvents,
        presentationName,
        status
      });
    }

    if (dcf) {
      const { applicationType, uri, logoUri, name } = dcf;

      dcf = clean({
        applicationType,
        logoUri,
        name,
        uri
      });
    }

    if (digitalCardFeatures) {
      const { content, contentType, style, width, height } = dcf;

      digitalCardFeatures = clean({
        content,
        contentType,
        height,
        style,
        width
      });
    }

    return clean({
      countryCode,
      dateOfCardCreated,
      dateOfCardLastUsed,
      dcf,
      digitalCardData,
      digitalCardFeatures,
      maskedBillingAddress,
      maskedCardholderFirstName,
      maskedCardholderFullName,
      maskedCardholderLastName,
      panBin,
      panExpirationMonth,
      panExpirationYear,
      panLastFour,
      paymentAccountReference,
      paymentCardDescriptor,
      paymentCardType,
      srcDigitalCardId,
      tokenBinRange,
      tokenLastFour
    });
  });

  return { maskedCards, maskedConsumer };
}
//END GENAI@CHATGPT4
//END GENAI@CHATGPT4
//END GENAI@CHATGPT4
